/**
 * @visibleName keys
 * @since 0.22.0
 * @component
 */
export default function keys<O extends object>(object: O) {
  return Object.keys(object) as unknown as (keyof O)[];
}
